import { c as _c } from "react/compiler-runtime";
import React, { useContext, useMemo } from 'react';
import useSWR from 'swr';
import { TransformationExecution } from '../../../../../../../typings/TransformationExecution.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { TransformationExecutionsFiltersProps, TransformationExecutionsQueryProps } from '../../../../typings/TransformationExecution.interface';
import { extractFromArray, toArray } from '../../../../utils';
import { resolveRelativeDate } from '../../../../utils/date';
import Button from '../../../common/base/Button';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import { transformation_execution_list_filters } from '../../../common/Filters/FilterComponents';
import Filters from '../../../common/Filters/Filters';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useSearchQuery from '../../../hooks/useSearchQuery';
import TransformationLogDetails from './TransformationExecutionDetails';
import TransformationExecutionsList from './TransformationExecutionsList';
import { StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, ViewBreadcrumbsTitle } from '../../../layouts/ViewLayout';
import Divider from '../../../common/base/Divider';
export const extractFiltersFromQuery = (parsed_query: TransformationExecutionsQueryProps): TransformationExecutionsFiltersProps => {
  let date: {};
  if (typeof parsed_query.date === 'string') {
    const {
      relative,
      min,
      max
    } = resolveRelativeDate(parsed_query.date as string);
    date = {
      relative,
      min: min?.toISOString(),
      max: max?.toISOString()
    };
  } else {
    date = {
      max: extractFromArray(parsed_query.date?.max) as string,
      min: extractFromArray(parsed_query.date?.min) as string
    };
  }
  return {
    date,
    webhook_id: toArray(parsed_query.webhook_id || []) as string[],
    log_level: toArray(parsed_query.log_level || []) as string[],
    next: extractFromArray(parsed_query.next) as string,
    prev: extractFromArray(parsed_query.prev) as string,
    issue_id: extractFromArray(parsed_query.issue_id) as string
  };
};
const TransformationExecutionsContent: React.FC<{
  transformation_id: string;
  onEdit: (execution?: TransformationExecution) => void;
  navElement: React.ReactElement;
}> = t0 => {
  const $ = _c(32);
  const {
    transformation_id,
    onEdit,
    navElement
  } = t0;
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== query.selected_execution_id) {
    t1 = extractFromArray(query.selected_execution_id);
    $[0] = query.selected_execution_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selected_execution_id = t1 as string;
  let t2;
  if ($[2] !== query) {
    t2 = extractFiltersFromQuery(query);
    $[2] = query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const filters = t2;
  let t3;
  if ($[4] !== updateSearchQuery) {
    t3 = selected_execution_id_0 => updateSearchQuery({
      selected_execution_id: selected_execution_id_0
    });
    $[4] = updateSearchQuery;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onExecutionSelected = t3;
  let t4;
  if ($[6] !== filters || $[7] !== updateSearchQuery) {
    t4 = new_filters => {
      const should_update = Object.entries(new_filters).some(t5 => {
        const [key, value] = t5;
        return JSON.stringify(filters[key]) !== JSON.stringify(value);
      });
      if (should_update) {
        updateSearchQuery(new_filters, {
          remove_keys: ["selected_execution_id", "next", "prev"]
        });
      }
    };
    $[6] = filters;
    $[7] = updateSearchQuery;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onFilterChanged = t4;
  let t5;
  if ($[9] !== updateSearchQuery) {
    t5 = pagination => {
      updateSearchQuery({
        prev: undefined,
        next: undefined,
        ...pagination
      }, {
        remove_keys: ["selected_execution_id"]
      });
    };
    $[9] = updateSearchQuery;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onPaginationChanged = t5;
  let t6;
  if ($[11] !== filters || $[12] !== onFilterChanged) {
    t6 = <Filters route="transformation-executions" filters={filters} components={transformation_execution_list_filters} onFilterChanged={onFilterChanged} />;
    $[11] = filters;
    $[12] = onFilterChanged;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== filters || $[16] !== onEdit || $[17] !== onExecutionSelected || $[18] !== onPaginationChanged || $[19] !== transformation_id) {
    t8 = <TransformationExecutionsList transformation_id={transformation_id} selected_execution_id={undefined} filters={filters} onPaginationChanged={onPaginationChanged} onExecutionSelected={onExecutionSelected} onEdit={onEdit} />;
    $[15] = filters;
    $[16] = onEdit;
    $[17] = onExecutionSelected;
    $[18] = onPaginationChanged;
    $[19] = transformation_id;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== navElement || $[22] !== t6 || $[23] !== t8) {
    t9 = <StyledViewContent>{navElement}{t6}{t7}{t8}</StyledViewContent>;
    $[21] = navElement;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== selected_execution_id || $[26] !== transformation_id || $[27] !== updateSearchQuery) {
    t10 = selected_execution_id && <TransformationLogDetails transformation_id={transformation_id} execution_id={selected_execution_id} onClose={() => updateSearchQuery({}, {
      remove_keys: ["selected_execution_id"]
    })} />;
    $[25] = selected_execution_id;
    $[26] = transformation_id;
    $[27] = updateSearchQuery;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
const TransformationExecutionsView: React.FC<{
  transformation_id: string;
  onEdit: (execution?: TransformationExecution) => void;
  onClose: () => void;
  in_modal?: boolean;
}> = t0 => {
  const $ = _c(31);
  const {
    transformation_id,
    onClose,
    onEdit,
    in_modal
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  let t1;
  if ($[0] !== transformation_id) {
    t1 = APIMethodKeys.transformations.get(transformation_id);
    $[0] = transformation_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.transformations || $[3] !== transformation_id) {
    t2 = () => HookdeckAPI.transformations.get(transformation_id);
    $[2] = HookdeckAPI.transformations;
    $[3] = transformation_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: transformation
  } = useSWR(t1, t2);
  if (in_modal) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        height: "100vh",
        overflow: "scroll",
        position: "relative"
      };
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        align: "center",
        gap: 4
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== onClose) {
      t5 = <Button onClick={onClose} outline={true} icon="close" />;
      $[7] = onClose;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        align: "center"
      };
      t7 = <Icon icon="transformation" left={true} />;
      $[9] = t6;
      $[10] = t7;
    } else {
      t6 = $[9];
      t7 = $[10];
    }
    const t8 = transformation?.name;
    let t9;
    if ($[11] !== t8) {
      t9 = <Div flex={t6}>{t7}<Text bold={true}>Executions of "{t8}"</Text></Div>;
      $[11] = t8;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    let t10;
    if ($[13] !== t5 || $[14] !== t9) {
      t10 = <StyledViewNav><StyledViewNavHeader><Div flex={t4}>{t5}{t9}</Div></StyledViewNavHeader></StyledViewNav>;
      $[13] = t5;
      $[14] = t9;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== onEdit || $[17] !== t10 || $[18] !== transformation_id) {
      t11 = <Div style={t3}><StyledViewLayout><TransformationExecutionsContent navElement={t10} transformation_id={transformation_id} onEdit={onEdit} /></StyledViewLayout></Div>;
      $[16] = onEdit;
      $[17] = t10;
      $[18] = transformation_id;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    return t11;
  }
  let t3;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      label: "Connections",
      to: "/connections"
    };
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const t4 = transformation?.name || "";
  const t5 = `/transformations/${transformation_id}`;
  let t6;
  if ($[21] !== t4 || $[22] !== t5) {
    t6 = {
      label: t4,
      to: t5,
      ellipsis: true,
      max_width_vw: 40
    };
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      label: "Executions"
    };
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6) {
    t8 = <StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={[t3, t6, t7]} /></StyledViewNavHeader>;
    $[25] = t6;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== onEdit || $[28] !== t8 || $[29] !== transformation_id) {
    t9 = <StyledViewLayout><TransformationExecutionsContent navElement={t8} transformation_id={transformation_id} onEdit={onEdit} /></StyledViewLayout>;
    $[27] = onEdit;
    $[28] = t8;
    $[29] = transformation_id;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default TransformationExecutionsView;